import { render } from "./Source.vue?vue&type=template&id=35630e2e"
import script from "./Source.vue?vue&type=script&lang=js"
export * from "./Source.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__